/**
 * Loading placeholder shown while TanStack Query is in-flight (UX-07).
 * Pure Tailwind animate-pulse — no external dep.
 *
 * Carried forward verbatim from packages/spa/src/components/ui/Skeleton.tsx.
 */
import { type HTMLAttributes } from 'react';

function cn(...classes: (string | false | undefined | null)[]): string {
  return classes.filter(Boolean).join(' ');
}

export function Skeleton({
  className,
  ...rest
}: HTMLAttributes<HTMLDivElement>): React.JSX.Element {
  return (
    <div
      role="status"
      aria-label="Loading"
      className={cn('animate-pulse rounded-md bg-ink-200', className)}
      {...rest}
    />
  );
}
